import { useMemo } from 'react'
import qs from 'qs'
import { useIntl, FormattedMessage } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'

import useOfferList from 'hooks/Offers/useOfferList'
import { getThemeClassName } from 'lib/theme/themeUtils'
import { CRUISE_BANK_OFFERS_FILTERS, CRUISE_ONLY_FLASH_OFFER_IDS } from 'constants/cruise'

const cruiseTourCarouselFilters: App.OfferListFilters = {
  ...CRUISE_BANK_OFFERS_FILTERS,
  offerSource: 'tours',
}

function CruisePageCruiseTourCarousel() {
  const intl = useIntl()
  const offerListOptions = useMemo(() => ({ excludedIds: CRUISE_ONLY_FLASH_OFFER_IDS }), [])
  const offerList = useOfferList(cruiseTourCarouselFilters, offerListOptions)

  const viewAllLabel = intl.formatMessage({
    id: 'WaDIRFn1uFiYKwi1LfxI',
    defaultMessage: 'View all',
    description: 'Button label on the Cruise Tour homepage carousel; navigates to cruise search results filtered to cruise tour products.',
  })

  if (!offerList.fetching && !offerList.offerIds.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          <FormattedMessage
            id="torK3HDdDbEkeajjnh1B"
            defaultMessage="Cruise <i>tours</i>"
            description="Section heading for the Cruise Tour product carousel on the cruises vertical homepage; the word tours is rendered in italics for emphasis."
            values={{ i: (chunks) => <i>{chunks}</i> }}
          />
        </Heading>

        <TextButton
          to={`/search/cruises?${qs.stringify(cruiseTourCarouselFilters, { arrayFormat: 'repeat' })}`}
          kind="tertiary"
          variant="dark"
        >
          {viewAllLabel}
        </TextButton>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageCruiseTourCarousel
